import { gql } from '@apollo/client';

const mutation = gql`
  mutation updatePaymentGatewayConfiguration(
    $gateway: String!, $paypalEnvironment: String, $paypalSandboxClientId: String, $paypalSandboxSecret: String,
    $paypalProductionClientId: String, $paypalProductionSecret: String, $paypalHost: String,
    $paypalClientId: String, $paypalSecret: String,
    $stripeEnvironment: String, $stripeTestPublishableKey: String, $stripeTestSecretKey: String,
    $stripeLivePublishableKey: String, $stripeLiveSecretKey: String
    ,$stripePublishableKey: String, $stripeSecretKey: String,
    $pawapayEnvironment: String, $pawapaySandboxToken: String, $pawapayLiveToken: String,
    $paymentName: String, $paymentSubtitle: String
  ) {
    updatePaymentGatewayConfiguration(
      gateway: $gateway, paypalEnvironment: $paypalEnvironment, paypalSandboxClientId: $paypalSandboxClientId,
      paypalSandboxSecret: $paypalSandboxSecret, paypalProductionClientId: $paypalProductionClientId,
      paypalProductionSecret: $paypalProductionSecret, paypalHost: $paypalHost, stripeEnvironment: $stripeEnvironment,
      stripeTestPublishableKey: $stripeTestPublishableKey, stripeTestSecretKey: $stripeTestSecretKey,
      stripeLivePublishableKey: $stripeLivePublishableKey, stripeLiveSecretKey: $stripeLiveSecretKey,
      paypalClientId: $paypalClientId, paypalSecret: $paypalSecret, stripePublishableKey: $stripePublishableKey, stripeSecretKey: $stripeSecretKey,
      pawapayEnvironment: $pawapayEnvironment, pawapaySandboxToken: $pawapaySandboxToken,
      pawapayLiveToken: $pawapayLiveToken, paymentName: $paymentName, paymentSubtitle: $paymentSubtitle
    ) { status errorMessage }
  }
`;

export const updatePaymentGatewayConfiguration = variables => {
  return async (dispatch, getState, { client }) => {
    const { data } = await client.mutate({ mutation, variables });
    return data?.updatePaymentGatewayConfiguration;
  };
};
